import * as React from "react";
import * as moment from 'moment';
import NavBar from "../components/NavBar";
import { Modal, Table, Button, ButtonToolbar } from "react-bootstrap";
import { LinkContainer, IndexLinkContainer } from "react-router-bootstrap";
import { RouteChildrenProps } from "react-router";
import AppUser from "../AppUser";
import { firestore, storage } from "firebase";
import * as fs from "../firestore";
import firebase from "../firebase";
import { DeviceList, WorkItem, makeFetchDeviceMastersQuery } from "./DeviceListImportFunc"
import "./DeviceListImportPage.css"


interface State {
    csv: string;
    readStatus: boolean,
    importStatus: boolean;
    showModal: boolean;
    popupModal: boolean;
    errorItem: WorkItem[];
    DeviceList: DeviceList[];
}

interface Props extends RouteChildrenProps {
    user: AppUser,
    onsubmit: (deviceState: string) => void
}

export default class DeviceListImportPage extends React.Component<Props, State, {}> {
    private onClickCSVImportBound: () => void;
    private file!: HTMLInputElement;
    private onClickCloseErrorPopupBound: () => void;
    private onClickCloseErrorListBound: () => void;
    private onClickShowErrorListBound: () => void;
    private onClickContinueBound: () => void;
    private onClickDeviceListBound: () => void;

    constructor(props: Props) {
        super(props);
        this.onClickCSVImportBound = this.onClickCSVImport.bind(this);
        this.onClickCloseErrorPopupBound = this.onClickCloseErrorPopup.bind(this);
        this.onClickCloseErrorListBound = this.onClickCloseErrorList.bind(this);
        this.onClickShowErrorListBound = this.onClickShowErrorList.bind(this);
        this.onClickContinueBound = this.onClickContinue.bind(this);
        this.onClickDeviceListBound = this.onClickDeviceList.bind(this);

        this.state = {
            csv: '',
            readStatus: false,
            importStatus: false,
            showModal: false,
            popupModal: false,
            errorItem: [],
            DeviceList: []
        };
    }

    async fetchDeviceMaster(): Promise<DeviceList[]> {
        const query = makeFetchDeviceMastersQuery();
        const rawDeviceList = (await query.get()).docs.map(doc => {
            const data = doc.data() as fs.DeviceList;
            return {id: doc.id, data};
        });
        return rawDeviceList.map(rawDeviceList => {
            return {
                id: rawDeviceList.id,
                ...rawDeviceList.data
            };
        });
    }

    SerialChk(item: WorkItem[], list: DeviceList[]): Boolean {
        var chkStatus = false;
        list.forEach( function(valuel, indexl) {
            item.forEach( function(valuei, indexi) {
                if (valuel.SerialNo === valuei.SerialNo) {
                    if (valuel.BluetoothAddress !== valuei.BluetoothAddress) {
                        item[indexi].errorNotes = "[" + valuel.BluetoothAddress +"] BluetoothAddress不正"
                        chkStatus = true;
                    }
                    else {
                        item[indexi].errorNotes = "登録済み"
                    }
                }
            })
        })
        return chkStatus;
    }

    BluetoothChk(item: WorkItem[], list: DeviceList[]): Boolean {
        var chkStatus = false;
        list.forEach( function(valuel, indexl) {
            item.forEach( function(valuei, indexi) {
                if (valuel.BluetoothAddress === valuei.BluetoothAddress) {
                    if (valuel.SerialNo !== valuei.SerialNo) {
                        item[indexi].errorNotes = "[" + valuel.SerialNo +"] SerialNo不正"
                        chkStatus = true;
                    }
                    else {
                        item[indexi].errorNotes = "登録済み"
                    }
                }
            })
        })
        return chkStatus;
    }

    getAddItem(item: WorkItem[]): WorkItem[] {
       return item.filter((i) => i.errorNotes === '' );
    }

    readFileAsText(file: Blob): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            const reader = new FileReader();
            reader.onerror = () => reject(reader.error);
            reader.onload = () => resolve((reader.result as string) || '');
            reader.readAsText(file);
        });
    }

    mapArrayToWorkItem(data: string[][]): WorkItem[] {
        return data
            .map((row) => {
                return {
                    errorNotes: row[0],
                    SerialNo: row[1], 
                    BluetoothAddress: row[2],
                    Status: row[1]
                };
            })  
            .filter((i) => i.errorNotes !== 'No.' && i.errorNotes ); // 無効行を除外。
    }   

    mapCSVToArray(csv: string): string[][] {
        return csv.split('\n').map((row) => row.split(','));
    }   

    chkItemData(item: WorkItem[]): boolean {
        var chkStatus = false;
        var chkAddress = false;
        var chkIndex = 0; 
        var maxIndex = 0; 
        var macstrchk = /^[A-F0-9]{2}$/; //MAC address

        item.forEach( function(value1, index1) {
            chkAddress = false;
            chkIndex = 0;
            item[index1].Status = "0";
            maxIndex = 0;
            value1.BluetoothAddress.split(':').forEach( function(value2, index2) { 
                if (!chkAddress) { 
                    if (!macstrchk.test(value2)) {
                        chkAddress = true;
                        chkIndex = index2+1;
                    }
                }
                maxIndex = index2+1;
            })
            if (chkAddress) {
                value1.errorNotes = "アドレス不正 第" +  chkIndex + "オクテット";
                chkStatus = true;
            }
            else {
                if (maxIndex !== 6) {
                    value1.errorNotes = "アドレス不正 オクテット数（" +  maxIndex + "）";
                    chkStatus = true;
                }
                else {
                    value1.errorNotes = "";
                }
            }
        });
        return chkStatus;
    }

    getErrorItem(item: WorkItem[]): WorkItem[] {
       return item.filter((i) => i.errorNotes !== '' );
    }

    async getCSV(file: Blob): Promise<string>{
        try {
            const csv = await this.readFileAsText(file);
            this.setState({
                csv: csv,
                readStatus: false
            })
            return csv;
        } catch (error) {
            this.setState({
                csv: '',
                readStatus: true,
                popupModal: true
            })
            return "";
        }
    }

    onClickCloseErrorPopup() {
        this.setState({
            popupModal: false
        })
    }

    onClickCloseErrorList() {
        this.setState({
            showModal: false,
            popupModal: false
        })
    }

    onClickShowErrorList() {
        this.setState({
            showModal: true
        })
    }

    onClickContinue() {
        this.setState({
            popupModal: false
        })
    }

    onClickDeviceList() {
        this.setState({
            popupModal: false
        })
        this.props.onsubmit("List");
    }

    async onClickCSVImport() {
        if (!this.file.files || !this.file.files[0]) {
            return;
        }
        const r = await this.getCSV(this.file.files[0]);
        const arr = this.mapCSVToArray(this.state.csv);
        const items = this.mapArrayToWorkItem(arr);
        const chk = this.chkItemData(items);

        if (chk) {
            const errorItem = this.getErrorItem(items);
            this.setState({
                importStatus: true,
                popupModal: true,
                errorItem: errorItem
            })
            return;
        }

        const DeviceList = await this.fetchDeviceMaster();
        this.setState({
            DeviceList
        });
        const SerialChk = this.SerialChk(items, DeviceList);
        if (SerialChk) {
            const errorItem = this.getErrorItem(items);
            this.setState({
                importStatus: true,
                popupModal: true,
                errorItem: errorItem
            })
            return;
        }
        const BluetoothChk = this.BluetoothChk(items, DeviceList);
        if (BluetoothChk) {
            const errorItem = this.getErrorItem(items);
            this.setState({
                importStatus: true,
                popupModal: true,
                errorItem: errorItem
            })
            return;
        }

        const DeviceMastersAddRef = firestore().collection(fs.Collection.DeviceMasters);
        const addItem = this.getAddItem(items);
        var errStatus = false;
        addItem.forEach( function(value) {
            try {
                DeviceMastersAddRef
                .add ({
                    "SerialNo": value.SerialNo,
                    "BluetoothAddress": value.BluetoothAddress,
                    "Status": value.Status,
                    "CreateDateTime": firebase.firestore.FieldValue.serverTimestamp(),
                    "WarrantyDate": "",
                })
            }
            catch (e) {
                value.errorNotes = "データ更新エラー"
                errStatus = true;
                return;
            }
        })
        if (errStatus) {
            this.setState({
                importStatus: true,
                popupModal: true,
                errorItem: addItem
            })
        }
        else {
            this.setState({
                importStatus: false,
                popupModal: true,
                errorItem: items
            })
        }

    }

    private renderPopupModal(): JSX.Element {

        const renderReadNGFooter = () => {
            return (
                <Modal.Footer>
                    <Button variant="primary" type="button" onClick={this.onClickCloseErrorPopupBound}>閉じる</Button>
                </Modal.Footer>
            );
        };

        const renderNGFooter = () => {
            return (
                <Modal.Footer>
                    <Button variant="primary" type="button" onClick={this.onClickShowErrorListBound}>エラーリストを見る</Button>
                </Modal.Footer>
            );
        };

        const renderOKFooter = () => {
            return (
                <Modal.Footer>
                    <Button variant="primary" type="button" onClick={this.onClickContinueBound}>続けて取込む</Button>
                    <Button variant="primary" type="button" onClick={this.onClickShowErrorListBound}>更新リストを見る</Button>
                    <Button variant="primary" type="button" onClick={this.onClickDeviceListBound}>機器一覧表示</Button>
                </Modal.Footer>
            );
        };

        return (
            <Modal
                show={this.state.popupModal}
                onHide={() => {
                    this.setState({ popupModal: false})}
                }
                dialogClassName="modal-40w"
                aria-labelledby="example-custom-modal-styling-title"
            >
                <Modal.Header>
                    <Modal.Title id="example-custom-modal-styling-title">
                        {"CSV Import処理"}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        this.state.readStatus ? "ファイル読込みでエラーが発生しました" : this.state.importStatus ? "エラーが発生しました" : "処理が正常終了しました"
                    }
                </Modal.Body>
                    {
                        this.state.readStatus ? renderReadNGFooter() : this.state.importStatus ? renderNGFooter() : renderOKFooter()
                    }
            </Modal>
        );
    }

    render() {
        return (
            <div>
                <NavBar {...this.props}/>
                <div className="import_main">
                    <p>CSVファイルを選択してください</p>
                    <input
                        type="file"
                        className="file"
                        ref={(file: HTMLInputElement) => (this.file = file)}
                        accept="text/csv"
                    />
                    <button className="read-button" onClick={this.onClickCSVImportBound}>取込</button>
                </div>
                <Modal
                    show={this.state.showModal}
                    onHide={() => this.setState({ showModal: false})}
                    dialogClassName="modal-60w"
                    aria-labelledby="example-custom-modal-styling-title"
                >
                    <Modal.Header>
                        <Modal.Title id="example-custom-modal-styling-title">
                            {
                                this.state.importStatus ? "Importエラーリスト" : "Importリスト"
                            }
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Table>
                            <thead>
                                <tr>
                                    <th>シリアル番号</th>
                                    <th>Bluetoothアドレス</th>
                                    <th>
                                        {
                                            this.state.importStatus ? "エラー内容" : "処理結果"
                                        }
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.errorItem.map((i, index) => (
                                <tr key={index}>
                                    <td align="center">{i.SerialNo}</td>
                                    <td align="center">{i.BluetoothAddress}</td>
                                    <td align="center">{i.errorNotes}</td>
                                </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Modal.Body>
                    <Modal.Footer>
                        <ButtonToolbar>
                            <Button variant="primary" type="button" onClick={this.onClickCloseErrorListBound}>閉じる</Button>
                        </ButtonToolbar>
                    </Modal.Footer>
                </Modal>
                {this.renderPopupModal()}
            </div>
        );
    }
}
